import React from 'react';
import YodleeLinkContent from './YodleeLinkContent';
import { YodleeLinkProvider } from './YodleeLinkContext';

export const YODLEE_FASTLINK_ELEMENT_ID = 'container-fastlink';

const Yodlee = ({ resource, onLoadLink, ...rest }) => {
  return (
    <YodleeLinkProvider resource={resource} onLoadLink={onLoadLink}>
      <YodleeLinkContent
        resource={resource}
        {...rest}
      />
    </YodleeLinkProvider>
  );
};

export default Yodlee;
